import {$events} from '../../helpers/events';
import {isElement, preventDefault} from '../../helpers/_utilities';
import {$dom} from '../../helpers/dom';
import variables from '../../variables';
import tippy from 'tippy.js';

const {
	exist,
	callAll,
	get,
	hasClass,
	removeClass,
	addClass,
	html
} = $dom;

export default function dropdown(
	rootSelector = '.js-dropdown',
	buttonSelector = '.js-dropdown-button',
	listSelector = '.js-dropdown-list',
	linkSelector = '.js-dropdown-link',
	tippySettings = {
		trigger: 'click',
		appendTo: 'parent',
		interactive: 'true',
		placement: 'bottom-end',
		allowHTML: true,
		arrow: false
	}
) {

	if (exist(rootSelector)) {
		const {active} = variables.classNames;

		function choose(event) {
			preventDefault(event);

			const
				currentLink = event.target.closest(linkSelector),
				currentDropdown = currentLink.closest(rootSelector),
				currentButton = get(buttonSelector, currentDropdown)
			;

			if (!hasClass(currentLink, active)) {
				callAll(linkSelector, link => {
					if (link === currentLink) {
						addClass(link, active)
					} else {
						removeClass(link, active);
					}
				}, currentDropdown);

				html(currentButton, html(currentLink))
			}

			currentButton._tippy.hide();
		}

		const
			init = () => {

				callAll(rootSelector, dropdown => {
					if (exist(buttonSelector, dropdown) && exist(listSelector, dropdown)) {

						const
							button = get(buttonSelector, dropdown),
							list = get(listSelector, dropdown)
						;

						tippy(button, Object.assign(tippySettings, {
							content: () => list.innerHTML
						}));
					}
				});

				$events.delegate.on('click tap', linkSelector, choose);
			},
			destroy = () => {
				callAll(buttonSelector, button => {
					button._tippy.destroy()
				});

				$events.delegate.off('click tap', linkSelector, choose);
			}
		;

		return {init, destroy}
	}


}
